import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
  Flex,
  Box,
} from '@chakra-ui/react';
import AleaCloseIcon from '../../icons/AleaCloseIcon.tsx';
import AleaCheckIcon from '../../icons/AleaCheckIcon.tsx';
import useModalHeaderZIndex from '../../hooks/useModalHeaderZIndex.ts';

interface AleaModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  onConfirm: () => void;
  confirmLabel: string;
  cancelLabel: string;
  variant: 'confirm' | 'info';
  children?: React.ReactNode;
  titleColor?: string;
}

const AleaModal: React.FC<AleaModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  onConfirm,
  variant,
  children,
  titleColor,
}) => {
  const variantStyles = {
    confirm: {
      headerColor: '#EF5B35',
    },
    info: {
      headerColor: '#EF5B35', // can change
    },
  };

  // Lower header z-index while modal is open (keeps modal above header)
  useModalHeaderZIndex(isOpen);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay zIndex={1500} />
      <ModalContent minWidth="380px" zIndex={1501}>
        <ModalHeader
          color={titleColor ? titleColor : variantStyles[variant].headerColor}
          fontSize="25px"
          fontWeight={500}
          textAlign="center"
          pt="25px"
        >
          {title}
        </ModalHeader>
        {description ||
          (children && (
            <ModalBody textAlign="center" color="black" pt={0} pb="12px">
              <Text>{description}</Text>
              <Box>{children}</Box>
            </ModalBody>
          ))}
        <ModalFooter pt={0} pb="25px">
          <Flex justifyContent="space-between" width="100%">
            {variant === 'info' ? (
              <Button
                variant="outline"
                onClick={onConfirm}
                h="50px"
                w="50%"
                borderColor="alea.500"
                borderRadius="13px"
                mx="auto"
              >
                <AleaCheckIcon size={29} />
              </Button>
            ) : (
              <>
                <Button
                  colorScheme="alea"
                  variant="solid"
                  onClick={onClose}
                  mr={3}
                  h="50px"
                  w="50%"
                  borderRadius="13px"
                >
                  <AleaCloseIcon />
                </Button>
                <Button
                  variant="outline"
                  onClick={onConfirm}
                  h="50px"
                  w="50%"
                  borderColor="alea.500"
                  borderRadius="13px"
                >
                  <AleaCheckIcon size={29} />
                </Button>
              </>
            )}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AleaModal;
